import { Component } from '@angular/core';

@Component({
  selector: 'app-stock-movement',
  standalone: false,
  
  templateUrl: './stock-movement.component.html',
  styles: ``
})
export class StockMovementComponent {

}
